import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { PricebookProduct } from '../../../admin/components/tools/PricingWizard/types';

export const PRICEBOOK_PRODUCTS_QUERY_KEY = 'pricebook/products';

export function usePricebookProductsQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useAdminUserSession();
	return useQuery({
		queryKey: [PRICEBOOK_PRODUCTS_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<PricebookProduct[]>('admin/BillingUtilities/GetPricebookProducts', 'GET'),
		enabled,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}
